export default {"src":"/_next/static/media/highlyExperiencedBadge.9caf9001.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};